import {BalanceObservation,CreationSessionSnapshot,type BalanceObservationData} from '@zzy/contracts';

export type CreationSession={accountId:string;siteId:string;source:string;sessionEpoch:string;csrf:string};
export type CreationAccount={scope:string;state:'loading'|'ready'|'error';balance?:BalanceObservationData;session?:CreationSession};
export const creationScope=(session:CreationSession)=>JSON.stringify([session.siteId,session.accountId,session.source,session.sessionEpoch]);

// A same-login refresh keeps the editor mounted while CSRF/balance refresh.
// A changed authoritative epoch removes the old editor before any new data.
export function observeCreationAccount(render:(value:CreationAccount)=>void,fetcher:typeof fetch=fetch){
 let version=0,disposed=false,controller:AbortController|undefined,current:CreationAccount={scope:'loading',state:'loading'};
 const publish=(value:CreationAccount)=>{current=value;render(value)};
 async function refresh(){
  controller?.abort();controller=new AbortController();const signal=controller.signal,ticket=++version;
  const live=()=>!disposed&&!signal.aborted&&version===ticket;
  try{
   const response=await fetcher('/api/v1/session',{cache:'no-store',credentials:'same-origin',signal}),json=await response.json();if(!live())return;
   if(!response.ok)throw Error('SESSION_REQUIRED');
   const session=CreationSessionSnapshot.parse(json.data),scope=creationScope(session);
   if(scope!==current.scope)publish({scope,state:'loading'});
   const result=await fetcher('/api/v1/account/balance',{cache:'no-store',credentials:'same-origin',signal}),payload=await result.json();if(!live())return;
   if(result.status===401||result.status===403)throw Error('SESSION_REQUIRED');
   const parsed=BalanceObservation.safeParse(payload.data);
   publish({scope,state:'ready',session,...(result.ok&&parsed.success&&parsed.data.accountId===session.accountId&&parsed.data.siteId===session.siteId?{balance:parsed.data}:{})});
  }catch{if(live())publish({scope:'invalid:'+ticket,state:'error'})}
 }
 return {refresh,dispose(){disposed=true;version++;controller?.abort()}};
}
